/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Button } from "./button.model";

@Component({
    selector: 'gm-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.less'],
    standalone: false
})
export class ModalComponent implements OnInit {
	@Input() modalTitle: string = '';
	@Input() buttons: Button[];
	@Input() visible: boolean = false;
	@Output() visibleChange : EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() message: string = '';
	@Input() class: string = 'modal-md';

	constructor() { }

	ngOnInit() {
	}

	hideModal(){
		this.visible = false;
		this.visibleChange.emit(this.visible);
	}

}
